/*
commonview/view_spinner

usage:
this module returnes a dom-element and some controls to display it

import viewSpinner from './view_spinner';
let mySpinner = viewSpinner.create({wrap:myDomElement});
mySpinner.show();

*/
import core from '../../common/lib/core.js';

const elements = {
	wrap: null,
	spinner: null,
	assembled: false
};
const classnameHide = 'u-hide';
const classnameShow = 'u-show';
const classnameDim = 'dim';
const create = core.create; /* create elements that can be inserted into the dom */

function createSpinner() {
	return create({
		type: 'div',
		class: 'spinner u-hide'
			/* set the z-index correctly with _z-index.scss. A value below 9 hides it due to the z-index of '.overlay' */
	});
}

function showSpinner() {
	core.removeClass(elements.spinner, classnameHide);
	core.addClass(elements.spinner, classnameShow);
	core.addClass(elements.wrap, classnameDim);
}

function hideSpinner() {
	core.removeClass(elements.spinner, classnameShow);
	core.addClass(elements.spinner, classnameHide);
	core.removeClass(elements.wrap, classnameDim);
}

function assembleElements() {
	/* create elements*/
	elements.spinner = createSpinner();
	elements.wrap.appendChild(elements.spinner);
	elements.assembled = true;
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	if (elements && elements.assembled) {
		core.deleteElementsInObjectExcept(elements, ['wrap'], 'view_spinner:46');
		elements.assembled = false;
	}
}

export default {
	create(p) {
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_spinner:57');
		assembleElements();
		return {
			show() {
				showSpinner();
			},
			hide() {
				hideSpinner();
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				hideSpinner();
				deleteAllElements();
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-spinner.js